import { getCanvasForExport } from '../visual/renderer';

export async function exportGif(durationMs: number = 5000): Promise<void> {
  const canvas = getCanvasForExport();
  if (!canvas) return;

  const progressEl = document.createElement('div');
  progressEl.className = 'gif-export-progress';
  progressEl.innerHTML = `
    <p class="gif-progress-text">Recording GIF...</p>
    <div class="gif-progress-bar-track">
      <div class="gif-progress-bar-fill" id="gif-progress-fill"></div>
    </div>
  `;
  document.body.appendChild(progressEl);
  const fill = document.getElementById('gif-progress-fill')!;

  const stream = canvas.captureStream(15);
  const chunks: BlobPart[] = [];
  const recorder = new MediaRecorder(stream, {
    mimeType: 'video/webm;codecs=vp8',
    videoBitsPerSecond: 2500000,
  });

  recorder.ondataavailable = (e) => {
    if (e.data.size > 0) chunks.push(e.data);
  };

  return new Promise((resolve) => {
    recorder.onstop = async () => {
      progressEl.remove();
      const blob = new Blob(chunks, { type: 'video/webm' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `hum-canvas-${Date.now()}.webm`;
      a.click();
      URL.revokeObjectURL(url);
      resolve();
    };

    recorder.start();

    const startTime = Date.now();
    const interval = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const pct = Math.min(100, (elapsed / durationMs) * 100);
      fill.style.width = `${pct}%`;
      if (elapsed >= durationMs) {
        clearInterval(interval);
        recorder.stop();
      }
    }, 100);
  });
}
